import React, { useState, useEffect } from 'react'
import { findIndex, isEmpty } from 'lodash-es'
import { useHistory, useParams } from 'react-router-dom'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ProjectDataTable from '../../../widgets/dataTable/ProjectDataTable'
import SelectedExpertList from '../../../widgets/selectedExpert/selecedExpertList/SelectedExpertList'
import { Panel } from 'rsuite'
import SeachExpertWidget from '../../../widgets/selectedExpert/seachExpert/SeachExpertWidget'
import pathname from '../../../constants/pathname'
import {
  getAssignExpertMutiData,
  getSchemaAssignExpertMuti,
  saveAssignExpertMittingMulti,
  saveAssignExpertMulti,
} from '../../../redux/actions/assignExpert'
import ConfirmWidget from '../../../widgets/confirm/ConfirmWidget'
import SeachExpert from '../../../widgets/selectedExpert/seachExpert/SeachExpert'

export default function AssignExpertMittingMulti() {
  const SELECTED_EXPERT = 'selectedExpertMulti'

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()

  const [isReLoading, setIsReLoading] = useState(false)
  const [requestBody, setRequestBody] = useState()
  const [projectList, setProjectList] = useState()
  // const [projectIdList, setProjectIdList] = useState()
  const [isOpenSearchExpert, setIsOpenSearchExpert] = useState(false)
  const [isShowConfimModal, setIsShowConfimModal] = useState(false)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  let history = useHistory()

  let _selectedExpert = []
  try {
    _selectedExpert = JSON.parse(sessionStorage.getItem(SELECTED_EXPERT)) || []
  } catch (e) {}

  const [selectedExpert, setSelectedExpert] = useState(_selectedExpert)

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let request = getRequestBody()
      console.log('handleGetSchema request', request)
      const _schema = await getSchemaAssignExpertMuti(request, 5, 1)
      console.log('handleGetSchema response', _schema)
      setSchema(_schema)
      setProjectList(_schema?.forms?.projectList)
    } catch (e) {
      console.log('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleReload = async (pagesize, pagenumber) => {
    setIsReLoading(true)
    startLoading()
    try {
      let request = getRequestBody()
      // console.log('handleReload request', request, 'pagesize', pagesize, 'pagenumber', pagenumber)
      const response = await getAssignExpertMutiData(request, pagesize, pagenumber)
      setProjectList(response)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsReLoading(false)
  }

  const handleSaveExpert = async (request) => {
    setIsReLoading(true)
    startLoading()
    try {
      // console.log(JSON.stringify(request))
      const response = await saveAssignExpertMittingMulti(request)

      doneLoading()
      // return history.push(`${pathname.proposal.review.attendanceRecordMulti}/${projectId}`)
      return history.push(`${pathname.proposal.review.attendanceRecordMulti}`)
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
    setIsReLoading(false)
  }

  const getRequestBody = () => {
    let request = requestBody
    if (!request) {
      let idList = sessionStorage.getItem('mutiReview')
      request = {
        id: idList,
      }
    }

    // setProjectIdList(request.id.split(','))
    setRequestBody(request)
    return request
  }

  const handleOnClickSelectExpert = (value, checked, data) => {
    setSelectedExpert((state) => {
      const dataIndex = findIndex(state, { id: data.id })
      if (dataIndex !== -1) {
        let newData = [...state]
        if (checked) {
          newData[dataIndex].isSelected = true
        } else {
          newData[dataIndex].isSelected = false
        }
        return newData
      } else {
        return [
          ...state,
          {
            id: data.id,
            name: data.name,
            email: data.email,
            isOnline: data.isOnline,
            isSelected: checked,
          },
        ]
      }
    })
  }

  const handleOnClickOnlineExpert = (value, checked, data) => {
    setSelectedExpert((state) => {
      const dataIndex = findIndex(state, { id: data.id })
      if (dataIndex !== -1) {
        let newData = [...state]
        if (checked) {
          newData[dataIndex].isOnline = true
        } else {
          newData[dataIndex].isOnline = false
        }
        return newData
      } else {
        return [
          ...state,
          {
            id: data.id,
            name: data.name,
            email: data.email,
            isOnline: checked,
            isSelected: false,
          },
        ]
      }
    })
  }

  useEffect(() => {
    if (!isEmpty(selectedExpert)) {
      sessionStorage.setItem(SELECTED_EXPERT, JSON.stringify(selectedExpert))
    }
  }, [selectedExpert])

  const onConfirm = () => {
    setIsShowConfimModal(false)

    const itemList = selectedExpert
      .filter((item) => item.isSelected)
      ?.map((item) => {
        return {
          id: item.id,
          isOnline: item.isOnline,
          isSelected: item.isSelected,
        }
      })

    const request = {
      projectVersionIds: projectList?.values?.map((item) => item.id),
      itemsList: itemList,
    }

    handleSaveExpert(request)
  }

  if (error) {
    return (
      <SidebarProposal isMultiReview>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isMultiReview>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isMultiReview>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      {schema?.forms?.reviewerSelectedList && (
        <div>
          <Panel
            shaded
            header={schema.forms.reviewerSelectedList.header}
            bordered
            collapsible
            defaultExpanded
          >
            <SelectedExpertList
              schema={schema.forms.reviewerSelectedList}
              selectedExpert={selectedExpert}
              onClick={() => {
                setIsOpenSearchExpert(true)
              }}
              confirm={() => {
                setIsShowConfimModal(true)
              }}
              confirmButtonText="ผู้ทรงคุณวุฒิไปยังทุกโครงการ"
              onHideSearchPanel={() => {
                setIsOpenSearchExpert(false)
              }}
              isOpenSearchExpert={isOpenSearchExpert}
              buttonText={schema.forms.reviewerSelectedList.buttonAddExpertLabel}
            />
          </Panel>
          <br />
        </div>
      )}

      {schema?.forms?.reviewerSearch && isOpenSearchExpert && (
        <div>
          <Panel shaded header={'ค้นหาผู้ทรงคุณวุฒิ'} bordered collapsible defaultExpanded>
            <SeachExpertWidget
              // {/* <SeachExpert */}
              schema={schema.forms.reviewerSearch}
              selectedExpert={selectedExpert}
              onClickSelect={handleOnClickSelectExpert}
              onClickOnline={handleOnClickOnlineExpert}
            />
          </Panel>
          <br />
        </div>
      )}

      {projectList && (
        <>
          <ProjectDataTable
            schema={projectList}
            pagination={true}
            onReload={handleReload}
            loading={isReLoading}
          />
          <br />
        </>
      )}

      <ConfirmWidget
        title={`ยืนยันการบันทึก`}
        show={isShowConfimModal}
        detail={`ยืนยันการบันทึกผู้ทรงคุณวุฒิไปยังทุกโครงการ`}
        onCancle={() => setIsShowConfimModal(false)}
        onConfirm={onConfirm}
      />
    </SidebarProposal>
  )
}
